import type { ISubscribePage } from 'generated/contentful';
import type { Subscribe } from 'models/contentful/subscribe/types';

export default function toSubscribe(content: ISubscribePage): Subscribe {
  return {
    welcomeText: content.fields.welcomeText,
    sidePic: { url: content.fields.sidePic.fields.file.url },
    signupText: content.fields.signupText,
    blockType: 'Subscribe',
  };
}
